/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import AppBar from "@material-ui/core/AppBar";
import "../constants/toolbars";
import { useStoreon } from "storeon/react";
import { SIZES } from "../constants";
import Navigation from "./Navigation";

const BottomToolbar = _ => {
  const { isMenuOpened } = useStoreon("isMenuOpened");

  return (
    <AppBar
      position="fixed"
      color="default"
      css={css`
        z-index: 100;
        top: auto;
        bottom: 0px;
        box-shadow: none;
        background: #262626;
        left: ${isMenuOpened ? SIZES.leftBarOpened : SIZES.leftBar}px;
        width: calc(
          100% - ${isMenuOpened ? SIZES.leftBarOpened : SIZES.leftBar}px
        );
        @media screen and (max-width: 480px) {
          z-index: 120;
          left: 0px;
          width: 100%;
        }
      `}
    >
      <Navigation />
    </AppBar>
  );
};

export default BottomToolbar;
